import './NotFoundPage.css';
import React, { JSX } from 'react';
import { localized } from '../../config/localization';
import { Button } from '../../components/Button/Button';
import { useNavigate } from 'react-router';

export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <span>404</span>
      <span>{localized.PAGE_NOT_FOUND}</span>
      <span>{localized.PAGE_NOT_FOUND_DETAILS}</span>
      <Button
        onClick={() => {
          navigate(-1);
        }}
      >
        {localized.BACK}
      </Button>
    </div>
  );
}
